// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/transact-preview/style.scss
// module id = 9
// module chunks = 0